// extracted by mini-css-extract-plugin
export default {"button":"Intro_button__p9cI3","glitch":"Intro_glitch__CJk94"};